import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import NotificationsDropdown from './NotificationsDropdown';
import '../styles/Dashboard.css';

const DashboardLayout = () => {
  const navigate = useNavigate();
  const [rotatingOpen, setRotatingOpen] = useState(true);
  const [toolsOpen, setToolsOpen] = useState(true);
  const [serversOpen, setServersOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleSignOut = () => {
    navigate('/');
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="dashboard-layout">
      {mobileMenuOpen && (
        <div className="mobile-overlay" onClick={closeMobileMenu}></div>
      )}

      <aside className={`dashboard-sidebar ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-logo">
          <NavLink to="/" className="sidebar-logo-link">
            <img src="/pathproxy.png" alt="PathProxy Logo" className="sidebar-logo-image" />
            <span className="logo-text">pathproxy</span>
          </NavLink>
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/dashboard" end className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9,22 9,12 15,12 15,22"/>
            </svg>
            <span>Dashboard</span>
          </NavLink>

          <div className="nav-item disabled">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
              <line x1="1" y1="10" x2="23" y2="10"/>
            </svg>
            <span>Topups</span>
          </div>

          <NavLink to="/dashboard/bandwidth" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"/>
              <line x1="16" y1="8" x2="2" y2="22"/>
              <line x1="17.5" y1="15" x2="9" y2="15"/>
            </svg>
            <span>Bandwidth Packages</span>
          </NavLink>

          <div className="nav-item disabled" title="Reseller Only">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
            <span>Subusers</span>
            <span className="nav-tooltip">Reseller Only</span>
          </div>

          <NavLink to="/dashboard/earn" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="1" x2="12" y2="23"/>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
            </svg>
            <span>Earn With Us</span>
          </NavLink>

          <div className="nav-section">
            <button className="nav-section-header" onClick={() => setRotatingOpen(!rotatingOpen)}>
              <span>Rotating Proxies</span>
              <svg className={`chevron ${rotatingOpen ? 'open' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="6,9 12,15 18,9"/>
              </svg>
            </button>
            {rotatingOpen && (
              <div className="nav-section-items">
                <NavLink to="/dashboard/rotating/monthly-residential" className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                  <span>Monthly Residential</span>
                </NavLink>
                <NavLink to="/dashboard/rotating/residential-basic" className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                  </svg>
                  <span>Residential Basic</span>
                </NavLink>
                <NavLink to="/dashboard/rotating/residential-premium" className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                  </svg>
                  <span>Residential Premium</span>
                </NavLink>
                <div className="nav-item sub-item disabled" title="Out Of Stock">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                  </svg>
                  <span>ISP</span>
                  <span className="nav-tooltip">Out Of Stock</span>
                </div>
                <div className="nav-item sub-item disabled" title="Out Of Stock">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                  </svg>
                  <span>Datacenter</span>
                  <span className="nav-tooltip">Out Of Stock</span>
                </div>
              </div>
            )}
          </div>

          <div className="nav-section">
            <button className="nav-section-header" onClick={() => setToolsOpen(!toolsOpen)}>
              <span>Tools</span>
              <svg className={`chevron ${toolsOpen ? 'open' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="6,9 12,15 18,9"/>
              </svg>
            </button>
            {toolsOpen && (
              <div className="nav-section-items">
                <NavLink to="/dashboard/tools/proxy-tester" className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
                  </svg>
                  <span>Proxy Tester</span>
                </NavLink>
                <div className="nav-item sub-item disabled">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M3 3v18h18"/>
                    <path d="M18 17V9"/>
                    <path d="M13 17V5"/>
                    <path d="M8 17v-3"/>
                  </svg>
                  <span>Rotating Traffic Logs</span>
                </div>
              </div>
            )}
          </div>

          <div className="nav-section">
            <button className="nav-section-header" onClick={() => setServersOpen(!serversOpen)}>
              <span>My Servers</span>
              <svg className={`chevron ${serversOpen ? 'open' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="6,9 12,15 18,9"/>
              </svg>
            </button>
            {serversOpen && (
              <div className="nav-section-items">
                <div className="nav-item sub-item disabled">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="2" y="2" width="20" height="8" rx="2" ry="2"/>
                    <rect x="2" y="14" width="20" height="8" rx="2" ry="2"/>
                    <line x1="6" y1="6" x2="6.01" y2="6"/>
                    <line x1="6" y1="18" x2="6.01" y2="18"/>
                  </svg>
                  <span>Servers</span>
                </div>
              </div>
            )}
          </div>

          <div className="nav-section">
            <button className="nav-section-header" onClick={() => setHelpOpen(!helpOpen)}>
              <span>Help</span>
              <svg className={`chevron ${helpOpen ? 'open' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="6,9 12,15 18,9"/>
              </svg>
            </button>
            {helpOpen && (
              <div className="nav-section-items">
                <NavLink to="/dashboard/tickets" className={({ isActive }) => `nav-item sub-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                  </svg>
                  <span>Tickets</span>
                </NavLink>
                <a href="https://discord.gg/pathproxy" target="_blank" rel="noopener noreferrer" className="nav-item sub-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                  </svg>
                  <span>Discord</span>
                </a>
                <a href="https://t.me/pathproxy" target="_blank" rel="noopener noreferrer" className="nav-item sub-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="22" y1="2" x2="11" y2="13"/>
                    <polygon points="22,2 15,22 11,13 2,9"/>
                  </svg>
                  <span>Telegram</span>
                </a>
              </div>
            )}
          </div>
        </nav>
      </aside>

      <main className="dashboard-main">
        <header className="dashboard-topbar">
          <button className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {mobileMenuOpen ? (
                <>
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </>
              ) : (
                <>
                  <line x1="3" y1="12" x2="21" y2="12"/>
                  <line x1="3" y1="6" x2="21" y2="6"/>
                  <line x1="3" y1="18" x2="21" y2="18"/>
                </>
              )}
            </svg>
          </button>
          <div className="topbar-right">
            <NotificationsDropdown />
            <NavLink to="/dashboard/profile" className="profile-avatar">
              <span>P</span>
            </NavLink>
          </div>
        </header>

        <div className="dashboard-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
